import React from 'react';
import PropTypes from 'prop-types';

import {Panel} from 'react-bootstrap';
import {Link} from 'react-router';

class RecentlyViewedClients extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
      recent_clients_open : true
		}

		this.renderRecentlyViewedClents = this.renderRecentlyViewedClents.bind(this);
	}

	renderRecentlyViewedClents(client, index, array) {
		var class_name;

		if(index === array.length - 1)
			class_name = 'individual-client-last'
		else
			class_name = 'individual-client'

		return (
			<div
				onClick={this.props.handleSelectClient}
				key={index}
				id={client._id}
				className={class_name}>
				<h5 className='col-md-6'>{client.name}</h5>
				<h5 className='col-md-6'>{(!client.email ? '(no email)' : client.email)}</h5>
			</div>
		)
	}

	render() {
		return (
			<div className='recently-viewed-clients-container panel'>
		  	{(() => {
		  		if(this.props.recently_viewed_clients && this.props.recently_viewed_clients.length > 0) {
		  			return (
		  				<div>
		  					{/* <div className='panel-heading'>
						  		<div className='col-md-11 col-xs-11'>
						      	<h2 className='panel-title recent-clients-panel'>
						      		Recently Viewed Clients
						      	</h2>
						    	</div>
						    	<div
						    		className={
						    			'pull-right recent-clients-caret ' +
						    			(this.state.recent_clients_open ?
						    			'fa fa-caret-up' :
						    			'fa fa-caret-down')
						    		}
						    		onClick={() => {this.setState({
						    			recent_clients_open : !this.state.recent_clients_open
						    		})}}
						    	/>
						    </div> */}
						  	{/* <Panel collapsible expanded={this.state.recent_clients_open}> */}
									{this.props.recently_viewed_clients.map(this.renderRecentlyViewedClents)}
								{/* </Panel> */}
		  				</div>
		  				)
		  		}
		  		else {
		  			return (
		  				<div className='row'>
      					<div className='col-md-12 col-xs-12'>
          				<div
          					id='select-role-alert'
          					className='alert alert-info'>
	          				<h4>No clients have been viewed.<strong><Link to='/clients/'> Click Here </Link></strong>to view or edit your clients.</h4>
	          			</div>
	          		</div>
          		</div>
		  				)
		  		}
		  	})()}
		  </div>
		)
	}
}

export default RecentlyViewedClients;



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/recentlyViewedClients.js